module.exports = __webpack_public_path__ + "static/media/london-28.c1cda92d.svg";